'use strict';
mpangoApp.controller('MeventController',MeventController);
function MeventController($rootScope,$scope,$state,$window, Mreports, Mevent, Notification, $filter, SweetAlert, $uibModal) {
	$scope.datePickerOpen = function() {
        $scope.popup.opened = true;
    };
    $scope.popup = {
        opened: false
    };
    $scope.datePickerOpen1 = function() {
        $scope.popup1.opened = true;
    };
    $scope.popup1 = {
        opened: false
    };
    $scope.exportDoc = function(tempname,xtype, id) {
        Mreports.toExcel(tempname,xtype,id).success(function  (data,status) {
            var token = $rootScope.sytoken;
            var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&token='+token;
            $window.open(url);
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num) {};
    $scope.$on('$viewContentLoaded', function () {
        Mevent.getEvent().success(function  (data,status) {
            $scope.mevents = data;
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    }); 
    $scope.open = function  (templatename,size) {
        var modalInstance = $uibModal.open({
            templateUrl: templatename,
            keyboard: false,
            backdrop: 'static',
            size: size,
            resolve:{
                tablename:function  () {
                    return $scope.mevents;
                }
            },
            controller: function  ($scope,tablename, $uibModalInstance) {
                $scope.add = function  (eventdata,valid) {
                    if (valid == true) {
                        $uibModalInstance.close();
                        angular.extend(eventdata,{user_id:$scope.currentUser.id});
                        Mevent.postEvent(eventdata).success(function  (data,status) {
                            $scope.mevents = tablename;
                            $scope.mevents.push(data.insertedD);
                            Notification.success({message: data.message});
                        }).error(function(data,status){
                            $state.go('auth');
                            Notification.error({message: 'Token expired, please login', delay: 3000});
                        }); 
                    }
                };
                $scope.cancel = function  () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };
    $scope.update = function(eventdata,formname,index) {
        SweetAlert.swal({
            title: "Are you sure?",
            text: "",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
            cancelButtonText: "No, cancel!",
            closeOnConfirm: true,
            closeOnCancel: true }, 
        function(isConfirm){ 
            if (isConfirm) {
                Mevent.updateEvent(eventdata,formname).success(function(data) {
                    if (formname == 'deactivate' || formname == 'activate') {
                        $state.reload();
                        Notification.success({message: data.message});
                    };
                    if (formname == 'eventupdate') {
                        Notification.success({message: data.message});
                    };
                }).error(function(data,status){
                    $state.go('auth');
                    Notification.error({message: 'Token expired, please login', delay: 3000});
                });
             
           } else {
              SweetAlert.swal("Cancelled", "Your data is safe!", "error");
           }
        });
    };
}
MeventController.$inject = ['$rootScope','$scope','$state','$window', 'Mreports', 'Mevent', 'Notification', '$filter', 'SweetAlert', '$uibModal'];